import { connect } from 'react-redux';
import { AppState } from '../../../../../types/store';
import { PostsType, PostsSortOrder } from '../../../../../types/posts';
import { getPostsDeviationsStreamId } from '../../../../streams/posts';
import {
  isCurrentUserProfileOwner,
  getProfileOwnerUser,
} from '../../../../selectors/users';
import { actions as ModalActions } from '@wix/da-shared-react/pkg/Modals';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';

import {
  selectors as streamSelectors,
  withOffset,
} from '@wix/da-shared-react/pkg/Stream';

import { getDeviationsByIds } from '@wix/da-shared-react/pkg/redux/deviations/selectors';

const mapStateToProps = (
  state: AppState,
  ownProps: { sortOrder: PostsSortOrder }
) => {
  const pollsStreamId = getPostsDeviationsStreamId({
    type: PostsType.POLLS,
    sortOrder: ownProps.sortOrder,
  });
  const polls = getDeviationsByIds(
    state,
    streamSelectors.getItems(state, pollsStreamId)
  );

  return {
    streamId: pollsStreamId,
    items: polls,
    hasMore: streamSelectors.hasMore(state, pollsStreamId),
    isFetching: streamSelectors.isFetching(state, pollsStreamId),
    isOwner: isCurrentUserProfileOwner(state),
    ownerUsername: getProfileOwnerUser(state).username,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const pollsStreamId = getPostsDeviationsStreamId({
    type: PostsType.POLLS,
    sortOrder: ownProps.sortOrder,
  });
  return {
    fetchMore: () => dispatch(withOffset.actions.fetch(pollsStreamId)),
    openCreatePollModal: () =>
      dispatch(
        ModalActions.pushModal(ModalType.POLL_EDIT, { wrapInPopup: false })
      ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
);
